module.exports = __webpack_public_path__ + "img/yc-step-4-label.svg";